"use client";

import React from "react";
import { Button } from "@chakra-ui/react";
import GenericIcon from "@/shared/ui/actions/GenericIcon";
import { iconSizePresets } from "@/shared/config/iconSizePresets";
import useChatBot from "../hooks/useChatBot";

export default function ChatProfileButton() {
  const { handleChatWithProfileClick, loadingKnowledge, preparingChat } =
    useChatBot();

  const label = loadingKnowledge ? "Loading..." : "Chat";

  const disabled = preparingChat;

  return (
    <Button
      aria-label={label}
      variant="ghost"
      onClick={() => {
        void handleChatWithProfileClick();
      }}
      disabled={disabled}
      title={label}
    >
      <GenericIcon icon="chat" size={iconSizePresets.actionButton} />
    </Button>
  );
}
